import { InputWithLabel } from '@adotel/components'
import SearchIcon from '@material-ui/icons/Search'

import { getTranslate } from '../../localization'
import useStyles from './styles/SitekeysFilter.styles'

interface SiteKeyHeaderFilterProps {
  searchInputValue: string

  setsearchInputValue: React.Dispatch<React.SetStateAction<string>>
}

const SitekeysFilter: React.FC<SiteKeyHeaderFilterProps> = ({
  searchInputValue,
  setsearchInputValue
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <InputWithLabel
        placeholder={getTranslate('Search by name')}
        autoComplete="off"
        noHelperText
        fullWidth
        startIcon={<SearchIcon />}
        className={classes.searchInput}
        value={searchInputValue}
        onChange={(event) => {
          setsearchInputValue(event.currentTarget.value)
        }}
      />
    </div>
  )
}
export default SitekeysFilter
